module.exports = __webpack_public_path__ + "s1.no2.bc56a4d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/s1.no2.jpg
// module id = oTWm
// module chunks = 0